<rappider-ai-abstract-chat [aiFunctionId]="'1'"
                           [activeProjectId]="'a'"
                           [activePersonId]="'b'"
                           [selectedProjectModelId]="selectedProjectModelId"
                           [actionCardItems]="actionCardItems"
                           [actionButtons]="actionButtons"></rappider-ai-abstract-chat>
